import { Accordion } from '@/components'

const Questions = ({ data, swiperData }) => {
  return (
    <>
      {data.map(question => {
        const { id, question: title, answer } = question
        return (
          <Accordion key={id} title={title} swiperData={swiperData}>
            {answer}
          </Accordion>
        )
      })}
    </>
  )
}

export default Questions
